function getView(viewName, title) {
    return (resolve, reject) => {
        require.ensure([], (require) => {
            let modules = require(`src/views/page/ems/report/${viewName}`)
            modules.default.options.metaInfo = { title }
            resolve(modules)
        }, reject, 'plan')
    }
}

let routes = [
    {
        name: 'reportList',
        path: '/ems/reportList',
        meta: {
            title: '报告列表'
        }
    },
    {
        name: 'reportDetail',
        path: '/ems/reportDetail',
        meta: {
            title: '报告原件'
        }
    },
    {
        name: 'reportItemDetail',
        path: '/ems/reportItemDetail',
        meta: {
            title: '报告原件'
        }
    },
    {
        name: 'reportEditor',
        path: '/ems/reportEditor',
        meta: {
            title: '报告原件'
        }
    }
]

routes.forEach((v) => {
    if (!v.redirect && !v.component) {
        v.component = getView(v.name, v.meta.title)
    }
})

export default routes



// WEBPACK FOOTER //
// ./src/router/modules/ems/report.js